export { default } from './LightBox';
